import { ElementType, Fragment, ReactNode } from "react";
import { useInView } from "@/hooks/useInView";
import { cn } from "@/lib/utils";

interface RevealProps {
  as?: ElementType;
  delay?: number;
  className?: string;
  children: ReactNode;
}

/** Fades and lifts its content in the first time it enters the viewport. */
const Reveal = ({ as: Tag = "div", delay = 0, className, children }: RevealProps) => {
  const { ref, inView } = useInView<HTMLElement>();

  return (
    <Tag
      ref={ref}
      className={cn("reveal", inView && "is-visible", className)}
      style={{ transitionDelay: inView ? `${delay}ms` : undefined }}
    >
      {children}
    </Tag>
  );
};

/** Splits a heading into words that rise into place one after another. */
export const SplitWords = ({ text, baseDelay = 0, step = 45 }: { text: string; baseDelay?: number; step?: number }) => (
  <>
    {text.split(/\s+/).map((word, i, words) => (
      <Fragment key={i}>
        <span className="split-word">
          <span style={{ animationDelay: `${baseDelay + i * step}ms` }}>{word}</span>
        </span>
        {i < words.length - 1 ? " " : null}
      </Fragment>
    ))}
  </>
);

export default Reveal;
